export const constants = {
  UPLOAD_BASE_URL: "https://sismobile.htu.edu.jo/uploads/",
  DOCUMENTS_BASE_URL: "https://sismobile.htu.edu.jo/Documents/",
  UPLOAD_BASE_URL2: "https://htu.edu.jo/uploads/",
};
